import i18n from "i18n"

export function getInvoiceTypeDisplay(row) {
  if (row.cancelledAt) {
    return { label: i18n.t("invoices.typeCancelled"), color: "error" }
  }
  if (row.correctedBy) {
    return { label: i18n.t("invoices.typeCorrected"), color: "error" }
  }
  switch (row.invoiceType) {
    case "corrective":
      return { label: i18n.t("invoices.typeCorrective"), color: "warning" }
    case "credit-note":
      return { label: i18n.t("invoices.typeCreditNote"), color: "info" }
    case "debit-note":
      return { label: i18n.t("invoices.typeDebitNote"), color: "success" }
    default:
      return { label: i18n.t("invoices.typeStandard"), color: "success" }
  }
}

export function getRectificationStatusDisplay(row) {
  switch (row.rectificationStatus) {
    case "substituted":
      return {
        label: i18n.t("invoices.rectificationStatusSubstituted"),
        color: "error",
      }
    case "fully_rectified":
      return {
        label: i18n.t("invoices.rectificationStatusFull"),
        color: "warning",
      }
    case "partially_rectified":
      return {
        label: i18n.t("invoices.rectificationStatusPartial"),
        color: "info",
      }
    default:
      return null
  }
}

export function getInvopopStatusDisplay(
  invopopStatus,
  { issued = false } = {},
) {
  switch (invopopStatus) {
    case "not_sent":
      // Un borrador siempre está en `not_sent`, así que ahí no es una anomalía y se deja sin
      // chip. En una factura ya emitida sí lo es: tiene número pero no llegó a Verifactu.
      return issued
        ? {
            label: i18n.t("invoices.invopopStatus.not_sent"),
            color: "error",
          }
        : null
    case "pending":
      return {
        label: i18n.t("invoices.invopopStatus.pending"),
        color: "default",
      }
    case "processing":
      return {
        label: i18n.t("invoices.invopopStatus.processing"),
        color: "info",
      }
    case "sent":
      return { label: i18n.t("invoices.invopopStatus.sent"), color: "success" }
    case "accepted":
      return {
        label: i18n.t("invoices.invopopStatus.accepted"),
        color: "success",
      }
    case "accepted_with_incidents":
      return {
        label: i18n.t("invoices.invopopStatus.accepted_with_incidents"),
        color: "warning",
      }
    case "failing":
      return { label: i18n.t("invoices.invopopStatus.failing"), color: "error" }
    case "rejected":
      return {
        label: i18n.t("invoices.invopopStatus.rejected"),
        color: "error",
      }
    case "cancelled":
    case "void":
      return {
        label: i18n.t("invoices.invopopStatus.cancelled"),
        color: "error",
      }
    case "error":
      return { label: i18n.t("invoices.invopopStatus.error"), color: "error" }
    default:
      return null
  }
}

export function getInvoiceSignedAmount(inv) {
  const sign = inv.invoiceType === "credit-note" ? -1 : 1
  return sign * (Number(inv.total) || 0)
}
